import React from "react";

export function Field({ label, children, hint }) {
  return (
    <div>
      <label className="block font-mono-caps text-xs tracking-[0.3em] uppercase text-white/50 mb-2">{label}</label>
      {children}
      {hint && <p className="mt-1 text-xs text-white/40">{hint}</p>}
    </div>
  );
}

export function Input(props) {
  return (
    <input {...props} className={`w-full bg-black/60 border border-white/10 focus:border-[#ff8a3c] focus:outline-none rounded-lg px-3 py-2.5 text-white text-sm placeholder:text-white/30 transition-colors ${props.className || ""}`} />
  );
}

export function Textarea(props) {
  return (
    <textarea {...props} className={`w-full bg-black/60 border border-white/10 focus:border-[#ff8a3c] focus:outline-none rounded-lg px-3 py-2.5 text-white text-sm placeholder:text-white/30 resize-y transition-colors ${props.className || ""}`} />
  );
}

export function Select(props) {
  return (
    <select {...props} className={`w-full bg-black/60 border border-white/10 focus:border-[#ff8a3c] focus:outline-none rounded-lg px-3 py-2.5 text-white text-sm transition-colors ${props.className || ""}`} />
  );
}

export function SectionTitle({ title, subtitle, right }) {
  return (
    <div className="flex items-end justify-between mb-6 gap-4 flex-wrap">
      <div>
        <h2 className="font-display text-3xl leading-none">{title}</h2>
        {subtitle && <p className="mt-2 text-white/50 text-sm">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Card({ children, className = "" }) {
  return (
    <div className={`rounded-xl border border-white/10 bg-black/40 p-5 ${className}`}>
      {children}
    </div>
  );
}

export const ICON_OPTIONS = [
  "radio", "mic", "film", "music", "headphones", "disc", "shield", "target", "sparkles", "drum", "users", "heart",
];
